import { cva, VariantProps } from 'class-variance-authority'
import React from 'react'

import { classes } from '../utils'

export const inputVariants = cva(
  [
    '!ring-0 flex h-8 w-full rounded-md border border-border-normal text-foreground-normal bg-transparent px-3 py-1 transition-colors placeholder:text-foreground-subtle disabled:cursor-not-allowed disabled:opacity-50 drop-shadow-sm bg-background',
    'outline-none focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-focus-outline focus:outline-focus-outline focus:outline-2 focus:outline-offset-[-2px] text-base',
  ],
  {
    variants: {
      size: {
        default: 'h-8',
        sm: 'h-7',
      },
      isInvalid: {
        true: 'focus-visible:outline-border-critical focus:outline-border-critical text-fill-critical',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
)

export type InputVariantProps = VariantProps<typeof inputVariants>

export type RawInputProps = InputVariantProps &
  React.InputHTMLAttributes<HTMLInputElement>

const RawInput = React.forwardRef<HTMLInputElement, RawInputProps>(
  ({ className, type, size, isInvalid, ...props }, ref) => {
    return (
      <input
        type={type}
        className={classes(inputVariants({ size, isInvalid }), className)}
        ref={ref}
        {...props}
      />
    )
  },
)
RawInput.displayName = 'RawInput'

export { RawInput }
